import React from "react";
import EditableText from "../edit/EditableText";
import PageCopyright from "../edit/PageCopyright";
import { PAGE_TITLE_STYLE } from "../edit/textStyles";

function OfferingPage() {
  return (
    <div className="main-content" style={{ maxWidth: 800, margin: "0 auto", padding: 24 }}>
      <EditableText id="offering.title" defaultContent="奉献" defaultStyle={PAGE_TITLE_STYLE} />
      <h1 style={{ textAlign: "center", position: "absolute", left: "-9999px" }}>奉献</h1>
      <section style={{ margin: "32px 0", textAlign: "left" }}>
        <a
          href="https://givebutter.com/untitled-campaign-zpjhvb"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            background: "#ffffff",
            color: "#1976d2",
            border: "5px solid #1976d2",
            padding: "14px 36px",
            borderRadius: 80,
            textDecoration: "none",
            fontWeight: 700,
            fontSize: "1.1em",
          }}
        >
          <EditableText
            id="offering.online-btn"
            as="span"
            defaultContent="网上奉献"
            defaultStyle={{ color: "#1976d2", fontWeight: 700, fontSize: "1.1em" }}
          />
        </a>
      </section>
      <section style={{ margin: "32px 0" }}>
        <EditableText
          id="offering.check-title"
          as="h2"
          defaultContent="支票奉献"
          defaultStyle={{ color: "#1976d2", fontWeight: 700, fontSize: "1.1em" }}
        />
        <EditableText
          id="offering.check-body"
          defaultContent={"奉献给教会的支票抬头：River of Life Church.\n邮寄地址：River of Life Church, 600 E. Pennsylvania Ave., Urbana 61801."}
        />
      </section>
      <PageCopyright pageId="offering" />
    </div>
  );
}

export default OfferingPage;
